module.exports = __webpack_public_path__ + "img/18_28.f4ac64c4.png";